var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NationalSystem',{attrs:{"title":"WCP (Mobile)","filter":r => r.notebook === 'WCP-Mobile',"scan-results":_vm.scanResults}},[_vm._v(" WCP's Mobile extract contains all daily national activity. This file was not received (so far) on this day. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }